import { createSlice } from "@reduxjs/toolkit";
import { ReccurrenceEditItem } from "../../EditReccurrenceForm/Types";
import { DEFAULT_RECCURENCE_TIME } from "../../Helper/Constants";
import { getFormattedDate } from "../../Helper/Script";
import { RecursTypes } from "../../SchedulingEntries/Types";
import { Reducer } from "./Reducer";
import { IInitialState, ISchedueListResponse, SchedulingModes } from "./Types";

const startDate = new Date();
const endDate = startDate.setDate(startDate.getDate() + 1);
const time = DEFAULT_RECCURENCE_TIME;

export const initialState: IInitialState = {
  isScheduleListPage: false,
  mode: SchedulingModes.CREATE,
  isEndBy: true,
  isEndAfter: false,
  schedulingDetails: {
    scheduleName: "",
    recurrenceType: RecursTypes.Daily,
    recurrenceRunTime: time,
    recurrenceRangeStart: getFormattedDate(new Date(), false),
    recurrenceRangeEnd: getFormattedDate(new Date(endDate), false),
    activeInLive: true
  },
  scheduleList: {} as ISchedueListResponse,
  scheduleInstances: [],
  isValidScheduleName: true,
  isShowSchedulePopup: false,
  schedulingRecurrenceItem: {} as ReccurrenceEditItem,
  enableSchedulingPopupSave: false,
  pickerConfigList: [],
  schedulingId: 0,
};

export const Slice = createSlice({
  initialState,
  name: "create-schedule",
  reducers: Reducer,
});
